import { Avatar } from '@citrite/citrix-ui';
import { Tooltip } from 'antd';
import { useAsync } from 'react-async-hook';
import { Loader } from '../../../common/loader/Loader';
import { AVATAR_LIMIT } from '../../../constants/constants';
import { AvatarFieldProps } from '../Fields';
import { AvatarGroupContainer, AvatarsContainer, AvatarText } from '../Fields.styled';
import { stringToArray } from '../utils';

export const AvatarViewField = ({ fieldValue, getUsers }: AvatarFieldProps) => {
	const overflowCount = fieldValue?.length - AVATAR_LIMIT;
	const { loading, result } = useAsync(async () => {
		return await getUsers(fieldValue as string[]);
	}, [fieldValue]);
	const avatarValue = stringToArray(fieldValue);

	const getInitials = (firstName: string, lastName: string) => {
		const firstInitial = firstName?.trim().substring(0, 1)?.toLocaleUpperCase() || '';
		const lastInitial = lastName?.trim()?.substring(0, 1)?.toLocaleUpperCase() || '';
		return firstInitial + lastInitial;
	};
	const getFullName = (firstname?: string, lastname?: string) => {
		return [firstname?.trim(), lastname?.trim()].join(' ');
	};

	const getAvatarUrl = (userId: string) => {
		const hostnameParts = window.location.hostname.split('.');
		hostnameParts[0] = 'sf-assets';
		return `https://${hostnameParts.join('.')}/avatar/${userId}`;
	};
	if (loading) {
		return <Loader height="30px" />;
	}

	return (
		<AvatarGroupContainer className="avatar-group">
			<AvatarsContainer>
				{avatarValue &&
					Array.isArray(avatarValue) &&
					avatarValue.slice(0, AVATAR_LIMIT).map((user: string) => {
						const person = result && result.find((item: any) => item.Id === user);
						if (person) {
							return (
								<Tooltip
									title={getFullName(person?.FirstName, person?.LastName)}
									placement="top"
									key={person?.Id}
									trigger={['focus']}
								>
									<Avatar
										label={getInitials(person.FirstName, person.LastName)}
										src={getAvatarUrl(person.Id)}
										size={32}
									/>
								</Tooltip>
							);
						}
						return null;
					})}
			</AvatarsContainer>
			{avatarValue.length === 1 && (
				<AvatarText>
					{getFullName(result?.[0]?.FirstName, result?.[0]?.LastName)}
				</AvatarText>
			)}
			{overflowCount > 0 && (
				<Tooltip
					title={
						<div>
							{avatarValue.slice(AVATAR_LIMIT).map((user: string) => {
								const person = result?.find((item: { Id: string }) => item.Id === user);
								return person ? (
									<div key={person.Id}>
										{getFullName(person?.FirstName, person?.LastName)}
									</div>
								) : null;
							})}
						</div>
					}
					placement="top"
					trigger={['focus']}
				>
					<AvatarText>
						{'+'}
						{overflowCount}
					</AvatarText>
				</Tooltip>
			)}
		</AvatarGroupContainer>
	);
};
